import App from '@/portals/flame-companion-forge/App.vue'
import router from '@/portals/flame-companion-forge/router'
import { bootstrapPortal } from './boot'

bootstrapPortal({
    App,
    router,
    elId: 'flame-companion-forge-root',
    portalName: 'Flame Companion Forge',
})
